<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>88、Shipper(发货方)</span>
				<span>{{ data5.jz401 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz402 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz403" />
			</li>
			<li>
				<span>89、B/L Number(提单号)</span>
				<span>{{ data5.jz404 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz405 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz406" />
			</li>
			<li>
				<span>90、Consignee(收货人)</span>
				<span>{{ data5.jz407 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz408 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz409" />
			</li>
			<li>
				<span>91、port of loading(装货港)</span>
				<span>{{ data5.jz410 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz411 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz412" />
			</li>
			<li>
				<span>92、port of discharging(卸货港)</span>
				<span>{{ data5.jz413 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz414 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz415" />
			</li>
			<li>
				<span>93、Commodity(货物名称)</span>
				<span>{{ data5.jz416 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz417 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz418" />
			</li>
			<li>
				<span>94、Weight of cargo(重量)</span>
				<span>{{ data5.jz419 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz420 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz421" />
			</li>
			<li>
				<span>95、Quantity(数量)</span>
				<span>{{ data5.jz422 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz423 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz424" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workStart5',
	components: {
		navTop
	},
	data() {
		return {
			data5: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					this.data5 = res.data4;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		p {
			color: #00fff0;
			font-size: 25px;
			line-height: 1em;
			text-align: center;
			font-weight: bold;
			margin-bottom: 10px;
		}
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
